<template>
    <div class="mvt-maplayers layer">
        <div class="layer-content">
            <button type="button" class="mvt-maplayers-close" @click="closePopup"></button>
            <div class="grid xs-grid-cols-1">
                <div class="grid xs-grid-cols-3 gap-1">
                    <span class="wrap text-bold">Map Type</span>
                    <a  class="btn secondary toggle small" @click="switchMapType('roadmap')" :class="{'active': (mapType !== 2 && mapType !== 3)}">Map</a>
                    <a  class="btn secondary toggle small" @click="switchMapType(2)" :class="{'active': mapType === 2}">Satellite</a>
                    <a  class="btn secondary toggle small" @click="switchMapType(3)" :class="{'active': mapType === 3}">Terrain</a>
                </div>
                <div class="grid xs-grid-cols-3 gap-1">
                    <span class="wrap text-bold">Map Details</span>
                    <a role="button" class="btn secondary toggle small" @click="switchLayer('traffic')" :class="{'active': mapDetails === 'traffic'}">
                        <i class="icon-car"></i>
                        <span>Traffic</span>
                    </a>
                    <a role="button" class="btn secondary toggle small" @click="switchLayer('transit')" :class="{'active': mapDetails === 'transit'}">
                        <i class="icon-poi-train"></i>
                        <span>Transit</span>
                    </a>
                    <a role="button" class="btn secondary toggle small" @click="switchLayer('biking')" :class="{'active': mapDetails === 'biking'}">
                        <i class="icon-bicycle"></i>
                        <span>Biking</span>
                    </a>
                </div>
                <div class="grid xs-grid-cols-2 gap-1">
                    <span class="wrap text-bold">Nearby Places</span>
                    <a role="button" class="btn secondary toggle small" @click="updatePoi('grocery')" :class="{'active': getSelectedPoi.includes('grocery')}">
                        <i class="icon-poi-grocery"></i>
                        <span>Groceries</span>
                    </a>
                    <a role="button" class="btn secondary toggle small" @click="updatePoi('cafes')" :class="{'active': getSelectedPoi.includes('cafes')}">
                        <i class="icon-coffee"></i>
                        <span>Cafes</span>
                    </a>
                    <a role="button" class="btn secondary toggle small" @click="updatePoi('restaurants')" :class="{'active': getSelectedPoi.includes('restaurants')}">
                        <i class="icon-poi-eat"></i>
                        <span>Restaurants</span>
                    </a>
                    <a role="button" class="btn secondary toggle small" @click="updatePoi('parks')" :class="{'active': getSelectedPoi.includes('parks')}">
                        <i class="icon-park"></i>
                        <span>Parks</span>
                    </a>
                    <a role="button" class="btn secondary toggle small" @click="updatePoi('shopping')" :class="{'active': getSelectedPoi.includes('shopping')}">
                        <i class="icon-poi-shopping"></i>
                        <span>Shopping</span>
                    </a>
                    <a role="button" class="btn secondary toggle small" @click="updatePoi('transits')" :class="{'active': getSelectedPoi.includes('transits')}">
                        <i class="icon-poi-bus"></i>
                        <span>Transit</span>
                    </a>
                </div>
                <div class="map-schools grid xs-grid-cols-2 gap-1">
                    <div class="wrap flex middle">
                        <span class="text-bold">Schools</span>
                        <i class="icon-toggle f0 lh-small"
                            :class="{ 'icon-toggle-on': showSchoolFilter, 'icon-toggle-off': !showSchoolFilter }"
                            @click="toggleMapSchools()"
                        ></i>
                    </div>
                    <template v-if="showSchoolFilter">
                        <a role="button" class="btn secondary toggle small" @click="schoolFilter('schoolPre')" :class="{'active': schoolPre === 1}">Pre-K & Elementary</a>
                        <a role="button" class="btn secondary toggle small" @click="schoolFilter('schoolCharter')" :class="{'active': schoolCharter === 1}">Charter</a>
                        <a role="button" class="btn secondary toggle small" @click="schoolFilter('schoolMiddle')" :class="{'active': schoolMiddle === 1}">Middle</a>
                        <a role="button" class="btn secondary toggle small" @click="schoolFilter('schoolPrivate')" :class="{'active': schoolPrivate === 1}">Private</a>
                        <a role="button" class="btn secondary toggle small" @click="schoolFilter('schoolHigh')" :class="{'active': schoolHigh === 1}">High</a>
                        <a role="button" class="btn secondary toggle small" @click="schoolFilter('schoolPublic')" :class="{'active': schoolPublic === 1}">Public</a>
                    </template>
                </div>
                <div v-if="showSchoolFilter" class="grid xs-grid-cols-1 gap-1">
                    <div class="flex middle">
                        <span class="text-bold">Great Schools Rating</span>
                        <mvtCheckbox theme="small" :data="schoolUnrated" v-model="schoolIncludeUnrated"></mvtCheckbox>
                    </div>
                    <mvtRadio class="grid small xs-grid-cols-5 gap-1 buttons toggle"  v-model="schoolMinRate" :data="scoreList"/>
                </div>
            </div>
        </div>
    </div>
</template>
<script src="./mvt-maplayers.js"></script>
<style lang="scss">
@use "./mvt-maplayers.scss" as *;
</style>